import { useContext } from 'react';
import { GenerateStakeholderImportTemplateJobContext } from './context';

export default function useGenerateStakeholderImportTemplateJobContext() {
  return useContext(GenerateStakeholderImportTemplateJobContext);
}
